import loadable from '@loadable/component'

const ImageBoxes = loadable(() => import('./ImageBoxes'))
const Collection = loadable(() => import('./Collection'))
const List = loadable(() => import('./List'))
const ImageGrid = loadable(() => import('./ImageGrid'))
const IframePlayer = loadable(() => import('./IframePlayer'))
const Title = loadable(() => import('./Title'))
const Divider = loadable(() => import('./Divider'))

const blockElements = {
  list: List,
  square: ImageBoxes,
  double: props => <ImageBoxes perRow={2} {...props} />,
  doubleSquare: props => <ImageBoxes perRow={2} {...props} />,
  collection: Collection,
  grid: ImageGrid,
  banner: props => <ImageBoxes ratio={2} {...props} />,
  player: IframePlayer,
  title: Title,
  divider: Divider,
  // tall: props => <ImageBoxes ratio={2 / 3} {...props} />,
}

export default blockElements
